import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import './../Forgetpassword/Forget.scss';
import { useFormik } from 'formik';
import classNames from 'classnames';
// import { PostRequest } from '../../../service/postRequest';
import { InputText } from 'primereact/inputtext';
import { useDispatch } from 'react-redux';
import OtpInput from 'react-otp-input';
import { handlePostRequest } from '../../services/PostTemplate';
import { useNavigate } from 'react-router-dom';

const SubmitOTP = ({ userDetails }) => {
    const [loading, setloading] = useState(false);
    // const [loadingIcon, setloadingIcon] = useState('');
    const [otp, setOtp] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        formik.setFieldValue('email', userDetails?.email);
    }, [userDetails]); // eslint-disable-line

    const formik = useFormik({
        initialValues: {
            email: '',
            otp: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'Email is required.';
            }
            return errors;
        },
        onSubmit: async (data) => {
            console.log('Data', data);
            setloading(true);
            const newData = {
                email: String(data.email),
                OTP: String(data.otp)
            };

            const res = await dispatch(handlePostRequest(newData, `/api/Auth/validateOTP`, true, true, '', '', true));
            formik.resetForm();
            if (res?.success === true) {
                sessionStorage.setItem('loggedInUser', 'Y');
                navigate('/change-password', { state: { email: data.email } });
            }
            setloading(false);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="Forget__Body">
            <div className="Otp__Container" id="container">
                <div className="form-container sign-in-container">
                    <form action="#" className="Login__Form" onSubmit={formik.handleSubmit}>
                        <div className="p-mb-4">
                            <h3 className="text-2xl font-semibold mt-2 mb-4 text-center">FORGOT PASSWORD</h3>
                        </div>
                        <div className="p-mt-4">
                            <div className="p-text-left">
                                <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>
                                    Email
                                </label>
                                <InputText type="email" className={classNames({ 'p-invalid': isFormFieldValid('email') }, 'Forget__Input')} name="email" placeholder="Enter Email" value={formik.values.email || ''} onChange={formik.handleChange} />
                                {getFormErrorMessage('email')}
                            </div>
                            <div className="p-field col-12 md:col-4 pt-3 pb-3 mt-4">
                                <label htmlFor="otp" className={classNames({ 'p-error': isFormFieldValid('otp') })}>
                                    OTP
                                </label>
                            </div>
                            <div className="otpContainer mt-4">
                                <OtpInput value={formik.values.otp} onChange={(otp) => formik.setFieldValue('otp', otp)} numInputs={6} otpType="number" renderInput={(props) => <input {...props} />} />
                            </div>

                            <div className="mt-4">
                                <Button
                                    // loadingIcon={loadingIcon}
                                    disabled={loading}
                                    type="submit"
                                    className="Login__Button"
                                    label="Submit OTP"
                                    iconPos="right"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SubmitOTP;
